import {
  createRootStoreModel,
  type RootStoreModelEnvironment,
  type RootStoreModelInstance,
  type RootStoreModelSnapshotIn,
  type WithRootStore,
} from './RootStoreModel'
import { ControlMode } from '../models/CenterSettings/ControlModeModel'

let rootStore: RootStoreModelInstance | null = null

function createRootStore(rootStoreEnvironment: RootStoreModelEnvironment): RootStoreModelInstance {
  const rootStoreSnapshot: RootStoreModelSnapshotIn = {
    notificationStore: {},
    centerSettingsStore: {},
    navbarStore: {},
    loginStore: {},
    checklistReportsStore: {},
    usersStore: {},
    missionHistoryStore: {},
    checklistsStore: {},
    commonSettingsStore: {},
    partNumbersStore: {},
    discrepancyReportsStore: {},
    vehiclesStore: {},
    flightNetworkStore: {},
    mapEntitiesStore: {}
  }
  
  rootStore = createRootStoreModel(rootStoreSnapshot, rootStoreEnvironment)

  Object.assign(window, { rootStore })
  return rootStore
}

const getOrCreateRootStore = (rootStoreEnvironment: RootStoreModelEnvironment): RootStoreModelInstance =>
  rootStore || createRootStore(rootStoreEnvironment)

export const getOrCreateStore = (rootStoreEnvironment: RootStoreModelEnvironment): WithRootStore => ({
  store: getOrCreateRootStore(rootStoreEnvironment),
})

export function getRootStore(): RootStoreModelInstance {
  if (rootStore === null) {
    throw Error('Root store not yet initialized')
  }
  return rootStore
}

export function isOversightControl(): boolean {
  return getRootStore().commonSettingsStore.controlMode === ControlMode.OversightControl
}

export function getDeploymentId(): number {
  const commonSettingsStore = getRootStore().commonSettingsStore
  if (commonSettingsStore === null || commonSettingsStore.deploymentId === undefined) {
    throw Error('Common settings not yet loaded or cannot find deployment id.')
  }
  return commonSettingsStore.deploymentId
}

export function getDeploymentName(): string {
  const commonSettingsStore = getRootStore().commonSettingsStore
  if (commonSettingsStore === null || commonSettingsStore.deploymentName === undefined) {
    throw Error('Common settings not yet loaded or cannot find deployment name.')
  }
  return commonSettingsStore.deploymentName
}

export interface RootStoreEnvironment extends RootStoreModelEnvironment {}
